import {EntityBase} from "../../shared/entity/EntityBase";

const PACKAGE_MANAGER_FIELDS = {
    seq: { type: Number, defaultValue: 0 },
    packageId: { defaultValue: '' },
    packageName: { defaultValue: '' },
    price: { type: Number, defaultValue: 0 },
    category1: { defaultValue: '' },
    category2: { defaultValue: '' },
};

export class PackageManagerEntity extends EntityBase {
    constructor(data = {}) {
        super(data, PACKAGE_MANAGER_FIELDS);

        this.errors = [
            {condition: () => this.packageId === '', message: '상품ID가 없습니다.'},
            {condition: () => this.packageName === '', message: '상품명이 없습니다.'},
            {condition: () => this.price === 0, message: '가격이 없습니다.'},
            {condition: () => this.category1 === '', message: '분류1이 없습니다.'},
            {condition: () => this.category2 === '', message: '분류2가 없습니다.'},
        ];
    }

    getIdentityKey() {
        return 'packageId';
    }
}